// LoadingContext.js
import { createContext, useState, useContext } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);

  const showLoading = () => setLoadingCount((c) => c + 1);
  const hideLoading = () => setLoadingCount((c) => Math.max(c - 1, 0));

  return (
    <LoadingContext.Provider value={{ loadingCount, showLoading, hideLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
